import React from "react";

var signedSvg = function signedSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M9 9.616c.305-.275.496-.673.496-1.116C9.496 7.672 8.826 7 8 7s-1.496.672-1.496 1.5c0 .443.191.841.496 1.116V16h-.5L2.96 7.894a2.005 2.005 0 0 1 0-1.788l1.013-2.03a8.015 8.015 0 0 0 .734-2.263L5.007 0h5.985l.301 1.813c.131.787.379 1.55.734 2.263l1.012 2.03c.281.563.281 1.225 0 1.788L9.5 16H9z",
    fillRule: "evenodd"
  }));
};

signedSvg.defaultProps = {
  height: "16",
  viewBox: "0 0 16 16",
  width: "16",
  xmlns: "http://www.w3.org/2000/svg"
};
export var signed = {
  category: 'icon',
  colorable: true,
  name: 'signed',
  svg: signedSvg
};